import { render } from "./DatatableComponent.vue?vue&type=template&id=683af718&scoped=true"
import script from "./DatatableComponent.vue?vue&type=script&lang=js"
export * from "./DatatableComponent.vue?vue&type=script&lang=js"

import "./DatatableComponent.vue?vue&type=style&index=0&id=683af718&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-683af718"]])

export default __exports__